// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__F2jQJ","label":"styles_label__124QQ","input":"styles_input__mgKKO"};